import { useRequest } from 'ahooks';
import { storeUsers } from 'services/api/admin';
import { permissionNameIdMap } from 'hooks/business/useNewPermisson';
import { useTranslate } from '@tolgee/react';

/**
 * 1.当前子账号所属部门下，任意有店铺管理权限的账号昵称
 * 2.没有1的情况下，取超管的昵称，超管没昵称就显示超管的账号/邮箱/手机号
 */
export const useAnySuperUser = (storeId: string) => {
  const { t } = useTranslate();
  const { data, loading } = useRequest(
    () =>
      storeUsers({
        storeId,
        permId: permissionNameIdMap.店铺管理,
      }),
    {
      cacheKey: `storeUsers_${storeId}_${permissionNameIdMap.店铺管理}`,
      staleTime: 300000,
      ready: !!storeId,
    },
  );
  if (loading) return '';
  const superUser = data?.find((item) => item.hasSupervisorPermission);
  const manager = data?.find((item) => !item.hasSupervisorPermission);
  if (manager) {
    return manager.name;
  }
  if (superUser) {
    return superUser.name || superUser.account || superUser.email;
  }
  return t('department.超级管理员');
};
